import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { Heidari_data, joaquin_data } from '../../assets'

const Joaquin = () => {
  return (
    <>
    <PanelMemberTemplate {...joaquin_data}/>
    </>
  )
}

export default Joaquin